import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CreateOvertimeDialog from './CreateOvertimeDialog.vue';
import SelectScheduling from './components/select-scheduling.vue';
import { attendanceDailyRestDayCancel, attendanceDailyRestDaySet } from 'api/Attendance';
import { getAvatar } from '@/util/util';
import { createRange } from './rang';
import dayjs from 'dayjs';
export default {
  components: {
    CreateOvertimeDialog: CreateOvertimeDialog,
    SelectScheduling: SelectScheduling
  },
  data: function data() {
    return {
      loading: false,
      dialogVisible: false,
      params: {},
      details: {
        is_show_edit_shift: false
      },
      tableData: [],
      editShiftDialogVisible: false,
      restDayLoading: false,
      updatePunchTimeLoading: false,
      updatePunchTimeDialogVisible: false,
      currentRow: {},
      pickerOptions: {}
    };
  },
  computed: {
    isAttendanceDateBeforeToday: function isAttendanceDateBeforeToday() {
      return dayjs(this.params.attendance_date).isBefore(dayjs(), 'day');
    },
    showEditShiftButton: function showEditShiftButton() {
      return this.isAttendanceDateBeforeToday && this.details.is_show_edit_shift && this.$p('menu.work.frequency') && this.$p('menu.statistics.edit');
    },
    showRestDayButton: function showRestDayButton() {
      return this.isAttendanceDateBeforeToday && !(this.details.attendance_type === 3 || this.details.is_leave) && this.$p('menu.statistics.edit');
    },
    isRestDay: function isRestDay() {
      return +this.details.attendance_type === 2;
    },
    restDayButtonText: function restDayButtonText() {
      return this.isRestDay ? this.$t('23967_71c055b8') : this.$t('23967_871c055b');
    },
    restDayConfirmMessage: function restDayConfirmMessage() {
      var attendance_date = this.params.attendance_date;
      return this.isRestDay ? this.$t('23967_1c055b84', {
        date: attendance_date
      }) : this.$t('23967_c055b84a', {
        date: attendance_date
      });
    },
    restDayRequest: function restDayRequest() {
      return this.isRestDay ? attendanceDailyRestDayCancel : attendanceDailyRestDaySet;
    }
  },
  methods: {
    getAvatar: getAvatar,
    fetchData: function fetchData(params) {
      var _this = this;
      this.loading = true;
      this.$http({
        url: '/web/statistics/attendanceDetail',
        method: 'GET',
        params: params
      }).then(function (res) {
        _this.details = res.data;
        var attendance_list = _this.details.attendance_list;
        var shift = attendance_list.shift,
          record = attendance_list.record;
        if (Array.isArray(record)) {
          _this.tableData = record.map(function (item) {
            return _objectSpread({
              shift: shift,
              click_at_model: item.click_at || ''
            }, item);
          });
        }
      }).catch(function () {
        _this.dialogVisible = false;
      }).finally(function () {
        _this.loading = false;
      });
    },
    init: function init(params) {
      this.dialogVisible = true;
      this.params = params;
      this.fetchData(params);
    },
    openEditShiftDialog: function openEditShiftDialog() {
      this.editShiftDialogVisible = true;
    },
    handleEditShiftChange: function handleEditShiftChange() {
      this.fetchData(this.params);
    },
    openCreateOvertimeDialog: function openCreateOvertimeDialog() {
      this.$refs.CreateOvertimeDialog.init(this.params);
    },
    handleToggleRestDay: function handleToggleRestDay() {
      var _this2 = this;
      if (this.restDayLoading) return;
      this.$confirm(this.restDayConfirmMessage, this.restDayButtonText, {
        confirmButtonText: this.$t('131'),
        cancelButtonText: this.$t('66')
      }).then(function () {
        var _this2$params = _this2.params,
          staff_id = _this2$params.staff_id,
          attendance_date = _this2$params.attendance_date;
        _this2.restDayLoading = true;
        _this2.restDayRequest({
          staff_id: staff_id,
          attendance_date: attendance_date
        }).then(function () {
          _this2.fetchData(_this2.params);
          // this.$emit('confirm')
        }).finally(function () {
          _this2.restDayLoading = false;
        });
      });
    },
    openUpdatePunchTimeDialog: function openUpdatePunchTimeDialog(scope) {
      if (this.$p('menu.statistics.edit')) {
        this.currentRow = scope.row;
        this.currentRow.click_at_model = scope.row.click_at || '';
        this.pickerOptions = createRange(this.params.attendance_date);
        this.updatePunchTimeDialogVisible = true;
      }
    },
    handleUpdatePunchTime: function handleUpdatePunchTime() {
      var _this3 = this;
      var _this$params = this.params,
        staff_id = _this$params.staff_id,
        attendance_date = _this$params.attendance_date;
      var _this$currentRow = this.currentRow,
        attendance_category = _this$currentRow.attendance_category,
        click_at_model = _this$currentRow.click_at_model;
      this.updatePunchTimeLoading = true;
      this.$http({
        url: '/web/statistics/modifyClickAt',
        data: {
          staff_id: staff_id,
          attendance_date: attendance_date,
          attendance_category: attendance_category,
          click_at: click_at_model
        }
      }).then(function () {
        _this3.currentRow.click_at = click_at_model;
        _this3.updatePunchTimeDialogVisible = false;
        _this3.fetchData(_this3.params);
      }).finally(function () {
        _this3.updatePunchTimeLoading = false;
      });
    },
    handleConfirm: function handleConfirm() {
      this.dialogVisible = false;
      this.$emit('confirm');
    }
  }
};